// AppFolio property IDs for the Highgrove properties we actively onboard.
// The Highgrove admin tab lists ALL HGR-tagged units, but onboarding progress
// (status buckets, per-step funnel, and the completion max) is counted only
// over units whose propertyId is in this set. Kept as a hardcoded cohort — it's
// a fixed onboarding batch; edit + deploy to change it.
//
// String keys: unit.propertyId is String(raw.property_id) — see
// normalizeFirestoreUnit in src/utils/dataQueries.js.
export const HGR_ONBOARD_PROPERTY_IDS = new Set([
  '536', '528', '529', '530', '531', '532', '533', '534', '535', '537',
  '538', '541', '542', '543', '544', '546', '547', '548', '549', '550',
  '553', '586', '568', '569', '571', '527', '593', '594', '595', '596',
  '599', '601', '606', '608', '572', '573', '576', '577', '578', '579',
  '581', '583', '609', '587', '589', '555', '557', '560', '561', '563',
  '564', '565', '566', '567', '591',
]);
